<div class="bl-padding--32 bl-margin-bottom--16 bl-block-module" *ngIf="primaryDocFields.length > 0 && applicantList[0]">
  <h2 class="bl-font-color--black bl-font-weight--800 bl-font-size--22">
    {{applicantList[0].firstName}} {{applicantList[0].lastName}}
  </h2>
  <ng-container *ngFor="let field of primaryDocFields; let fieldIndex = index">
    <ecp-dynamic-requested-doc 
      [attr.data-automation-id]="'primary-documents-'+fieldIndex"
      [applicant]="applicantList[0]" [page]="page" [card]="card" [field]="field" [pageSubmitted$]="pageSubmitted$"
       *ngIf="field.visible"></ecp-dynamic-requested-doc>
  </ng-container>
</div>

<div class="bl-padding--32 bl-margin-bottom--16 bl-block-module" *ngIf="coApplicantDocFields.length > 0 && applicantList[1]">
  <h2 class="bl-font-color--black bl-font-weight--800 bl-font-size--22">
    {{applicantList[1].firstName}} {{applicantList[1].lastName}}
  </h2>
  <ng-container *ngFor="let field of coApplicantDocFields; let fieldIndex = index">
    <ecp-dynamic-requested-doc  
    [attr.data-automation-id]="'co-applicant-documents-'+fieldIndex"
      [applicant]="applicantList[1]" [page]="page" [card]="card" [field]="field" [pageSubmitted$]="pageSubmitted$"
       *ngIf="field.visible"></ecp-dynamic-requested-doc>
  </ng-container>
</div>

<div class="bl-padding--32 bl-margin-bottom--16 bl-block-module" *ngIf="additionalCoApplicantDocFields.length > 0 && applicantList[2]">
  <h2 class="bl-font-color--black bl-font-weight--800 bl-font-size--22">
    {{applicantList[2].firstName}} {{applicantList[2].lastName}}
  </h2>
  <ng-container *ngFor="let field of additionalCoApplicantDocFields; let fieldIndex = index">
    <ecp-dynamic-requested-doc  
      [attr.data-automation-id]="'second-co-applicant-documents-'+fieldIndex"
      [applicant]="applicantList[2]" [page]="page" [card]="card" [field]="field" [pageSubmitted$]="pageSubmitted$"
       *ngIf="field.visible"></ecp-dynamic-requested-doc>
  </ng-container>
</div>

<div class="bl-padding--32 bl-margin-bottom--16 bl-block-module" *ngIf="additionalCoApplicantDocFields.length > 0 && applicantList[3]">
  <h2 class="bl-font-color--black bl-font-weight--800 bl-font-size--22">
    {{applicantList[3].firstName}} {{applicantList[3].lastName}}
  </h2>
  <ng-container *ngFor="let field of additionalCoApplicantDocFields; let fieldIndex = index">
    <ecp-dynamic-requested-doc
      [attr.data-automation-id]="'third-co-applicant-documents-'+fieldIndex" 
      [applicant]="applicantList[3]" [page]="page" [card]="card" [field]="field" [pageSubmitted$]="pageSubmitted$"
       *ngIf="field.visible"></ecp-dynamic-requested-doc>
  </ng-container>
</div>